import { Carousel } from 'react-bootstrap';
import '../styles/Home.css'
import slide1 from '../assets/slide1.jpg';
import slide2 from '../assets/slide2.jpg';
import slide3 from '../assets/slide3.jpg';
import slide4 from '../assets/slide4.jpg';
import slide5 from '../assets/slide5.jpg';

export default function Home() {
  return (
    <div>
      <Carousel fade>
      <Carousel.Item>
          <img
            className="d-block w-100 hover-effect"
            src={slide1}
            alt="First slide"
            style={{ height: '85vh', objectFit: 'cover' }}
          />
          <Carousel.Caption>
            <h2>Product Design</h2>
            <p className="home-carousel-text">Future-ready Designs for modern Industries</p>
          </Carousel.Caption>
        </Carousel.Item>
        <Carousel.Item>
          <img
            className="d-block w-100 hover-effect"
            src={slide2}
            alt="First slide"
            style={{ height: '85vh', objectFit: 'cover' }}
          />
          <Carousel.Caption>
            <h2>Precision Manufacturing</h2>
            <p className="home-carousel-text">Serving a wide range of Customers related to various industries world-wide. <br />
               Performance of Highly precise and critical operations.  </p>
          </Carousel.Caption>
        </Carousel.Item>
        <Carousel.Item>
          <img
            className="d-block w-100 hover-effect"
            src={slide3}
            alt="Second slide"
            style={{ height: '85vh', objectFit: 'cover' }}
          />
          <Carousel.Caption>
            <h2>Flawless Surface Finishing</h2>
            <p className="home-carousel-text">Where every surface reflects perfections.</p>
          </Carousel.Caption>
        </Carousel.Item>
        <Carousel.Item>
          <img
            className="d-block w-100 hover-effect"
            src={slide4}
            alt="Third slide"
            style={{ height: '85vh', objectFit: 'cover' }}
          />
          <Carousel.Caption>
            <h3>Uncompromised Quality</h3>
            <p className="home-carousel-text">Where every Micron matters.</p>
          </Carousel.Caption>
        </Carousel.Item>
        <Carousel.Item>
          <img
            className="d-block w-100 hover-effect"
            src={slide5}
            alt="Third slide"
            style={{ height: '85vh', objectFit: 'cover' }}
          />
          <Carousel.Caption>
            <h3>Delivering Trust Worldwide</h3>
            <p className="home-carousel-text">Building global relations with every shipment</p>
          </Carousel.Caption>
        </Carousel.Item>
      </Carousel>
      <div className="container py-5 text-center">
        <h1 className="pt-2">Who we are</h1>
        <p className="lead">
          At the heart of Pune’s industrial hub, we are a precision machining company driven by innovation, accuracy, and uncompromised quality.
          
          With a state-of-the-art facility, we focus on producing low to medium volumes of high quality products at competitive prices.
          <br />
          As an ISO 9001:2015 certified company, we focus on following well-planned SOPs for delivering best quality products
          and innovative solutions to meet the evolving needs of our customers.
          <br />

          Our skilled team leverages advanced technology and rigorous quality
          control to ensure each product meets the highest standards.
          <br />
          We aim to build long-lasting relationships with our customers based on trust, transparency and mutual growth.
          We are eager in expanding our network of customers and suppliers across the globe.
        </p>
        <section className="py-4 bg-light text-center">
          <div className="container">
            <h1 className="mb-4">What we specialize in:</h1>
            <ul className="list-unstyled fs-5 specialization-list">
              <li className="mb-2">• Custom-machined components for Oil & Gas Industries</li>
              <li className="mb-2">• Dies and Molds</li>
              <li className="mb-2">• Defense-grade components</li>
              <li className="mb-2">• Agriculture sector equipments</li>
              <li className="mb-2">• One-off prototypes and bulk production</li>
            </ul>
          </div>
        </section>
        <p className="lead">
          Our commitment to quality and precision ensures that we meet the highest standards in every project. Whether you need a single prototype or a large batch of components, we have the expertise and technology to deliver.
        </p>
        <p className="lead">
          <a
            href="/contact"
            className="text-primary text-decoration-underline contact-link"
          >
            Contact us
          </a>{' '}
          today to learn how we can help you achieve your manufacturing goals.
        </p>
      </div>
    </div>
  );
}
